// pages/ResetPasswordPage.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Anchor, Button, Paper, PasswordInput} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import CustomSnackbar from '../components/CustomSnackbar';
import classes from './LoginLogout.module.css';
import Environment from '../utility/environment';

const ResetPasswordPage: React.FC = () => {
  const [password, setPassword] = useState<string>('');
  const [passwordConfirm, setPasswordConfirm] = useState<string>('');
  const [passwordSent, setPasswordSent] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [messageSent, setMessageSent] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const token = new URLSearchParams(location.search).get("token");

    useEffect(() => {
        // Extrai o token da URL
    const validateToken = async () => {
        try {
            const response = await fetch(`${Environment.VITE_API_URL}/validate_reset_token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                reset_token: token,}),
            credentials: 'include',  // Envia cookies na requisição
            });
            const data = await response.json();
            if (!data.valid) {
            alert(t('auth.resetPassword.invalidToken'));
            navigate("/login");
            }
        } catch (error) {
            console.error("Erro ao validar token:", error);
            alert(t('auth.resetPassword.internalError'));
            navigate("/login");
        }
        };

      validateToken();
    }, [token, navigate, t]);



  const handleSendPassword = async () => {
    const token = new URLSearchParams(location.search).get("token");
    // Simula o envio do e-mail de recuperação
    if (password !== passwordConfirm) {
        setMessage(t('auth.resetPassword.passwordsDoNotMatch'));
        setMessageSent(true);
      return;
    }
    else if (password.length < 6) {
        setMessage(t('auth.resetPassword.minLength'));
        setMessageSent(true);
      return;
    }
    else if (password.length > 20) {
        setMessage(t('auth.resetPassword.maxLength'));
        setMessageSent(true);
      return;
    }
    else if (!password.match(/[A-Z]/)) {
        setMessage(t('auth.resetPassword.uppercaseRequired'));
        setMessageSent(true);
      return;
    }
    else if (!password.match(/[0-9]/)) {
        setMessage(t('auth.resetPassword.numberRequired'));
        setMessageSent(true);
      return;
    }
    else if (!password.match(/[^a-zA-Z0-9]/)) {
        setMessage(t('auth.resetPassword.specialCharRequired'));
        setMessageSent(true);
      return;
    }

    try {
    const response = await fetch(`${Environment.VITE_API_URL}/api/v1/reset_password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          reset_token: token,
          new_password: password,
        }),
        credentials: 'include',  // Envia cookies na requisição
      });

      if (response.ok) {
        const data = await response.json();
        if (data.message) {
          setMessage(data.message);
        }
        setPasswordSent(true);
      }

    } catch (error) {
      console.error("ERRO INTERNO");
      setPasswordSent(false);
    }


  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.leftContainer} style={{ position: 'relative' }}>
        <Paper className={classes.form} radius={0} p={30}>
          <img src="/images/icon.png" alt="Logo" className={classes.logo} />
          {!passwordSent && (
            <>
              <PasswordInput
                label={t('auth.resetPassword.newPassword')}
                placeholder={t('auth.resetPassword.passwordPlaceholder')}
                size="md"
                value={password}
                onChange={(event) => setPassword(event.currentTarget.value)}
                className={classes.textInput}
                styles={{
                    visibilityToggle: {
                      border: '1px solid transparent',
                      borderRadius: '4px',
                      textAlign: 'left',
                      '&:hover': {
                        borderColor: '#204C3D !important',
                      },
                    },
                  }}
              />
              <PasswordInput
                label={t('auth.resetPassword.confirmPassword')}
                placeholder={t('auth.resetPassword.passwordPlaceholder')}
                size="md"
                value={passwordConfirm}
                onChange={(event) => setPasswordConfirm(event.currentTarget.value)}
                className={classes.textInput}
              />
              <Button
                fullWidth
                size="md"
                onClick={handleSendPassword}
                mt="xl"
                className={classes.customButton}
              >
                {t('common.send')}
              </Button>
            </>
          )}

          <Anchor<'a'>
            href="#"
            onClick={(event: { preventDefault: () => void; }) => {
              event.preventDefault();
              navigate('/login');
            }}
            className={classes.customAnchor}
            style={{ marginTop: 15, display: 'block' }}
          >
            {t('auth.backToLogin')}
          </Anchor>
        </Paper>
        {/* Snackbar exibido quando o e-mail é enviado com sucesso */}
        <CustomSnackbar
            opened={passwordSent}
            message={t('auth.resetPassword.success')}
            duration={2000}
            backgroundColor="green"
            onClose={() => navigate('/login')}
        />
        <CustomSnackbar
            opened={messageSent}
            message={message}
            duration={2000}
            backgroundColor="red"
            onClose={() => {setMessageSent(false)}}
        />
      </div>

      <div className={classes.divider} />

      <div className={classes.rightContainer} />
    </div>
  );
};

export default ResetPasswordPage;
